import {NoArgsConstructor, metaRegistry} from './Registry';
import {StringUtils} from './StringUtils';
import '../../utils/metadata-polyfill';

export interface FieldMetadata<P> {
    type: string;
    field: string;
    props?: P;
}

export type Environment = 'server' | 'client' | 'test' | 'priority';

export type PropertyAnnotationFunc = (
    target: object,
    ctx: ClassMemberDecoratorContext
) => void;

export function propertyAnnotationFactory(
    name: string,
    props?: any
): PropertyAnnotationFunc {
    return (_target: object, ctx: ClassMemberDecoratorContext): void => {
        //metaRegistry.markAsInjected(target);
        if (!ctx.metadata) {
            throw new Error('no metadata');
        }
        const metaData = (ctx.metadata[name] || []) as FieldMetadata<object>[];
        const typeName: string = StringUtils.firstUpperCase(String(ctx.name));
        metaData.push({
            field: String(ctx.name),
            props: props || {},
            type: typeName
        });

        ctx.metadata[name] = metaData;
    };
}

export function inject(): (
    target: any,
    ctx: ClassMemberDecoratorContext
) => void {
    return propertyAnnotationFactory('injects');
}

export function postConstruct(): (
    target: any,
    ctx: ClassMemberDecoratorContext
) => void {
    return propertyAnnotationFactory('postConstructs');
}

export interface SingletonOptions {
    global?: boolean;
    env?: Environment;
    devMode?: boolean;
}

export function singleton(
    name: string,
    options?: SingletonOptions
): (target: NoArgsConstructor<object>, ctx: ClassDecoratorContext) => void {
    return (
        target: NoArgsConstructor<object>,
        ctx: ClassDecoratorContext
    ): void => {
        metaRegistry.regSingleton(target, name, ctx, options);
    };
}
